export const LoadingIndicator = (props) => {
    return (<div class="loading-component">
        <div class="loader" />
        <div >{props.message}</div>
    </div>)
}